import React from "react";
import { Button, Card, Col, Drawer, Icon, Input, Menu, notification, Popconfirm, Row, Select, Tooltip } from "antd";
import { getUrlPushWrapper, getUrlQuery } from "../../routes";
import SMS from "../communication/sms";
import EmailDrawer from "../communication/emailDrawer";
import Request from "../../request";
import styles from "../studentHeader/styles.less";
import { connect } from "react-redux";
import ListFollowUps from "../../components/_utils/listFollowUp";
import { RightsWrapper } from "../../components/_utils/utils";
import setting from "../../components/_utils/settings";
import { BrowserRouter as Router, Link } from "react-router-dom";
import {
    FaArchive,
    FaBookDead,
    FaWhatsapp
} from "react-icons/fa";
import TextArea from "antd/lib/input/TextArea";

const { Option } = Select;

let counsellingData = {};

const modernStyles = {
    menuWrapper: {
        background: '#f0f2f5',
        padding: '10px 15px',
        borderRadius: '12px',
        marginBottom: '20px'
    },
    mainMenu: {
        background: 'transparent',
        borderBottom: 'none',
        display: 'flex',
        alignItems: 'center',
        lineHeight: '45px',
    },
    primaryItem: {
        borderRadius: '8px',
        marginRight: '10px',
    },
    subMenu: {
        marginLeft: 'auto', // Pushes the "More" section to the right
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
    }
};


const deskName = {
    "Front Desk": 0,
    "Registration Desk": 1,
    "Application Desk": 2,
    "Visa Desk": 3,
    "Claim Desk": 4,
    "Archive Desk": 5,
};

class StudentHeader extends React.Component {
    state = {
        current: "mail",
        showSMS: false,
        showFollowUp: false,
        load: false,
        showDesks: true,
        visible: false,
        openApplicationDrawar: false,
        popUp: true,
        desk: "",
        allUsers: []
    };
    showSMS = () => {
        let userArr = {
            _id: this.props.data._id,
            emailId: this.props.data.emailId ? this.props.data.emailId : "",
            mobile: this.props.data.mobile ? this.props.data.mobile : "",
            studentName: this.props.data.studentName,
        };
        counsellingData = {
            usersData: [userArr],
        };
        this.setState({ showSMS: true });
    };
    showWhats = () => {
        const { mobile } = this.props.data;
        const message = "Hello"; // you can make this dynamic too

        if (!mobile) {
            console.warn("No mobile number found");
            return;
        }

        // clean number: remove spaces, +, and non-digits
        const phone = String(mobile).replace(/\D/g, '');
        const text = encodeURIComponent(message);
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        if (isMobile) {
            // try to open native app
            const appUrl = `whatsapp://send?phone=${phone}&text=${text}`;
            window.location.href = appUrl;

            // fallback to web if app is not installed
            setTimeout(() => {
                const waUrl = `https://wa.me/${phone}?text=${text}`;
                window.open(waUrl, "_blank", "noopener");
            }, 600);
        } else {
            // desktop users — open WhatsApp Web
            const waUrl = `https://web.whatsapp.com/send?phone=${phone}&text=${text}`;
            window.open(waUrl, "_blank", "noopener");
        }
    };
    handleClick = (e) => {
    };

    sendBack = async (level, promptReason) => {
        if (level !== 'Archive Desk' && level !== 'Dead Inquiry') {
            if (!this.state.moveReasonUser) {
                return notification.warning({
                    message: 'Select user by reason you move the student',
                });
            }
            if (!this.state.moveReasonType) {
                return notification.warning({
                    message: 'Select move reason type',
                });
            }
            if (!this.state.moveReason) {
                return notification.warning({
                    message: 'Move Reason is required, please mention a reason to move the student to another desk',
                });
            }
        }

        this.setState({ load: true });

        let x = await Request.changeDesk({
            _id: this.props.info ? this.props.info : this.props.data._id,
            atLevel: level,
            moveReason: this.state.moveReason,
            moveReasonType: this.state.moveReasonType,
            moveReasonUser: this.state.moveReasonUser,
            reason: promptReason
        });
        this.setState({ load: false });
        if (x.error) {
            notification.warning({
                message: x.message,
            });
        } else {
            if (level === "Front Desk") {
                level = "Counselling Desk";
            }
            notification.success({
                message: `Success! Student Moved To ${level}`,
            });
            this.props.done();
        }
    };
    deleteStudent = async () => {
        this.setState({ load: true });
        let x = await Request.deleteStudent({
            _id: this.props.data._id,
            atLevel: "Deleted",
        });
        this.setState({ load: false });

        if (x && !x.error) {
            notification.success({
                message: "Deleted Successfully",
            });

            this.props.done();
        } else {
            notification.error({ message: "Try again" });
        }
    };

    closeSMS = () => {
        this.setState({ showSMS: false });
    };
    showEmail = () => {
        let userArr = {
            _id: this.props.data._id,
            emailId: this.props.data.emailId ? this.props.data.emailId : "",
            mobile: this.props.data.mobile ? this.props.data.mobile : "",
            studentName: this.props.data.studentName,
        };
        counsellingData = {
            usersData: [userArr],
        };
        this.setState({ showEmail: true });
    };

    closeEmail = () => {
        this.setState({ showEmail: false });
    };

    async componentDidMount() {
        switch (this.props.pathname) {
            case "/inquiry/update":
                this.test("inquiryedit1");
                break;
            case "/desk/update-counselling":
                this.test("updateCousenlling");
                break;
            case "/registration/fees":
                this.test("registration");
                break;
            case "/desk/allApplication-desk/update":
                this.test("editApplication");
                break;
            case "/getFamilyAndFinance":
                this.test("addFamilyAndFinance");
                break;
            case "/documents":
                this.test("documents");
                break;
            case "/rating-history":
                this.test("rating-history");
                break;
            case "/activity":
                this.test("activity");
                break;
            case "/communication-history":
                this.test("communication-history");
                break;
            case "/desk/getClaim":
                this.test("claimProcessing");
                break;
            case "/desk/getVisa":
                this.test("visaProcessing");
                break;
            default:
                break;
        }
        let { data: allUsers } = await Request.loadDeskUser({
            results: 10000,
            isStudent: false,
            active: true,
            showAll: true
        });
        this.setState({ allUsers });
    }

    mainNew = (data) => {
        let promptResponse
        if (data.key === "archive" || data.key === "Dead Inquiry") {
            promptResponse = prompt(`Enter Valid Reason for moving Student to ${data.key} `);
            if (!promptResponse) {
                return
            }
        }
        const { info, rollBackLevel, dispatch } = this.props;

        let searchParams = new URLSearchParams(this.props.search)
        let inquiryId = searchParams.get('id')

        if (data.key === "inquiryedit1") {
            // dispatch(getUrlPushWrapper("inquiryedit1", { id: inquiryId }));
            dispatch(getUrlPushWrapper("inquiryeditv2", { id: inquiryId }));
        }
        switch (data.key) {
            case "rollback":
                this.sendBack(rollBackLevel);
                break;
            case "dead":
                this.sendBack("Dead Inquiry", promptResponse);
                break;
            case "archive":
                this.sendBack("Archive Desk", promptResponse);
                break;
            default:
        }
        if (data.key === "updateCousenlling") {
            dispatch(getUrlPushWrapper("updateCousenlling", { id: inquiryId }));
        }
        if (data.key === "registration") {
            dispatch(getUrlPushWrapper("registration.fee", { id: inquiryId }));
        }
        if (data.key === "editApplication") {
            dispatch(getUrlPushWrapper("editApplication", { id: inquiryId }));
        }
        if (data.key === "visaProcessing") {
            dispatch(getUrlPushWrapper("visaProcessing", { id: inquiryId }));
        }
        if (data.key === "claimProcessing") {
            dispatch(getUrlPushWrapper("claimProcessing", { id: inquiryId }));
        }
        if (data.key === "followUps") {
            this.setState({ showFollowUp: true });
            //dispatch(getUrlPushWrapper('followUp.follow', { id: inquiryId }))
        }
        if (data.key === "Enrollment") {
            dispatch(getUrlPushWrapper("desk.enrollment", { id: inquiryId }));
        }
        if (data.key === "addFamilyAndFinance") {
            dispatch(getUrlPushWrapper("addFamilyAndFinance", { id: inquiryId }));
        }
        if (data.key === "student-call-history") {
            dispatch(getUrlPushWrapper("student-call-history", { id: inquiryId }));
        }
        if (data.key === "activity") {
            dispatch(getUrlPushWrapper("activity", { id: inquiryId }));
        }
        if (data.key === "communication-history") {
            dispatch(getUrlPushWrapper("communication-history", { id: inquiryId }));
        }
        if (data.key === "rating-history") {
            dispatch(getUrlPushWrapper("rating-history", { id: inquiryId }));
        }
        if (data.key === "documents") {
            dispatch(getUrlPushWrapper("documents", { id: inquiryId }));
        }
        if (data.key === "communication:courier") {
            dispatch(getUrlPushWrapper("courier", { id: inquiryId }));
        }
        if (data.key === "student-moved-reason-notes") {
            dispatch(getUrlPushWrapper("student-moved-reason-notes", { id: inquiryId }));
        }
        if (data.key === "profile") {
            dispatch(getUrlPushWrapper("studentProfileDetails", { id: inquiryId }));
        }
    };
    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };
    test = (current) => {
        this.setState({
            current,
        });
    };

    static getDerivedStateFromProps(props, state) {
        let atLevel = props.data && props.data.atLevel ? props.data.atLevel : "";
        if (atLevel === "Visa Desk") {
            state.showDesks = true;
        }

        return { ...state };
    }

    render() {
        let { info, data, rollBackLevel } = this.props;
        let atLevel =
            this.props && this.props.data && this.props.data.atLevel
                ? this.props.data.atLevel
                : "";

        let { load, showDesks, desk, allUsers } = this.state;

        desk = desk ? desk : 'isCounsellor';

        let deskRights = {
            "Operation Manager Desk": "isOperationManager"
        };
        if (atLevel == 'Operation Manager Desk') {
            deskRights["Operation Manager Desk"] = "isOperationManager";
        } else if (atLevel == 'Front Desk') {
            deskRights["Operation Manager Desk"] = "isOperationManager";
            deskRights["Front Desk"] = "isCounsellor";
        } else if (atLevel == 'Registration Desk') {
            deskRights["Operation Manager Desk"] = "isOperationManager";
            deskRights["Front Desk"] = "isCounsellor";
            deskRights["Registration Desk"] = "isRegistration";
        } else if (atLevel == 'Application Desk') {
            deskRights["Operation Manager Desk"] = "isOperationManager";
            deskRights["Front Desk"] = "isCounsellor";
            deskRights["Registration Desk"] = "isRegistration";
            deskRights["Application Desk"] = "isAdmission";
        } else if (atLevel == 'Visa Desk') {
            deskRights["Operation Manager Desk"] = "isOperationManager";
            deskRights["Front Desk"] = "isCounsellor";
            deskRights["Registration Desk"] = "isRegistration";
            deskRights["Application Desk"] = "isAdmission";
            deskRights["Visa Desk"] = "isVisa";
        } else if (atLevel == 'Claim Desk') {
            deskRights["Operation Manager Desk"] = "isOperationManager";
            deskRights["Front Desk"] = "isCounsellor";
            deskRights["Registration Desk"] = "isRegistration";
            deskRights["Application Desk"] = "isAdmission";
            deskRights["Visa Desk"] = "isVisa";
            deskRights["Claim Desk"] = "isClaim";
        } else if (atLevel == 'Archive Desk') {
            deskRights["Operation Manager Desk"] = "isOperationManager";
            deskRights["Front Desk"] = "isCounsellor";
            deskRights["Registration Desk"] = "isRegistration";
            deskRights["Application Desk"] = "isAdmission";
            deskRights["Visa Desk"] = "isVisa";
            deskRights["Claim Desk"] = "isClaim";
        }

        let checkSelectedDesk = deskRights[desk];

        let inquiryUserIds = [];
        if (data && data.counsellorId && data.counsellorId._id) {
            inquiryUserIds.push(data.counsellorId._id);
        }
        if (data && data.operationManagerId) {
            inquiryUserIds.push(data.operationManagerId);
        }
        if (data && data.admissionUserId && data.admissionUserId.length > 0) {
            inquiryUserIds = [...inquiryUserIds, ...data.admissionUserId];
        }
        if (data && data.claimUserId && data.claimUserId.length > 0) {
            inquiryUserIds = [...inquiryUserIds, ...data.claimUserId];
        }
        if (data && data.registrationUserId && data.registrationUserId.length > 0) {
            inquiryUserIds = [...inquiryUserIds, ...data.registrationUserId];
        }
        if (data && data.visaUserId && data.visaUserId.length > 0) {
            inquiryUserIds = [...inquiryUserIds, ...data.visaUserId];
        }
        // allUsers = allUsers.filter( (user) => {
        //     return user[checkSelectedDesk] === true && inquiryUserIds.includes(user._id)
        // });
        let deskOptions = [];
        for (let key in deskRights) {
            deskOptions.push(<Option value={key} key={key}>{key == 'Front Desk' ? 'Counselling Desk' : key}</Option>)
        }

        const menuButtons = [
            { title: "Profile Sheet", icon: "user", color: styles.btnSuccess, key: "profile", right: null },
            { title: "Follow Ups", icon: "snippets", color: styles.btnPrimary, key: "followUps", right: "FollowUps.view" },
            { title: "SMS", icon: "message", color: styles.btnPrimary, action: () => this.showSMS(), right: null },
            { title: "WhatsApp", customIcon: <FaWhatsapp />, color: styles.btnPrimary, action: () => this.showWhats(), right: null },
            { title: "Email", icon: "mail", color: styles.btnSuccess, action: () => this.showEmail(), right: null },
            { title: "Courier", icon: "build", color: styles.btnPrimary, key: "communication:courier", right: null },
        ];
        return (

            <Card loading={load} className={[styles.wrapper, styles.stuHeaderCard]}>
                {this.state.showFollowUp ? (
                    <ListFollowUps
                        studentObj={data}
                        onClose={() => {
                            this.setState({ showFollowUp: false });
                        }}
                    />
                ) : null}
                {this.state.showSMS ? (
                    <SMS counsellingData={counsellingData} onClose={this.closeSMS} />
                ) : null}

                {this.state.showEmail ? (
                    <EmailDrawer
                        counsellingData={counsellingData}
                        onClose={this.closeEmail}
                    />
                ) : null}

                <Row>
                    <Col span={5} className={styles.headerMenuNew}>
                        <div style={{ display: 'flex', gap: '4px' }}>
                            {/* <React.Fragment>
                                <RightsWrapper>
                                    <Tooltip title="Profile Sheet">
                                        <Button
                                            shape="circle"
                                            size={"medium"}
                                            className={styles.btnSuccess}
                                            onClick={() => this.mainNew({ key: "profile" })}
                                            icon="user"
                                        />
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>

                            <React.Fragment>
                                <RightsWrapper myRight={"FollowUps.view"}>
                                    <Tooltip title="Follow Ups">
                                        <Button
                                            shape="circle"
                                            size={"medium"}
                                            className={styles.btnPrimary}
                                            onClick={() => this.mainNew({ key: "followUps" })}
                                            icon="snippets"
                                        />
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>

                            <React.Fragment>
                                <RightsWrapper>
                                    <Tooltip title="SMS">
                                        <Button
                                            shape="circle"
                                            size={"medium"}
                                            className={styles.btnPrimary}
                                            onClick={() => this.showSMS()}
                                            icon="message"
                                        />
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>

                            <React.Fragment>
                                <RightsWrapper>
                                    <Tooltip title="WhatsApp">
                                        <Button
                                            shape="circle"
                                            size={"medium"}
                                            className={styles.btnPrimary}
                                            onClick={() => this.showWhats()}
                                        > <FaWhatsapp /></Button>
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>

                            <React.Fragment>
                                <RightsWrapper>
                                    <Tooltip title="Email">
                                        <Button
                                            shape="circle"
                                            size={"medium"}
                                            className={styles.btnSuccess}
                                            onClick={() => this.showEmail()}
                                            icon="mail"
                                        />
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>
                            <React.Fragment>
                                <RightsWrapper>
                                    <Tooltip title="Courier">
                                        <Button
                                            shape="circle"
                                            size={"medium"}
                                            className={styles.btnPrimary}
                                            onClick={() =>
                                                this.mainNew({ key: "communication:courier" })
                                            }
                                            icon="build"
                                        />
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>
                            {rollBackLevel && !showDesks && (
                                <React.Fragment>
                                    <RightsWrapper myRight={"RollBack.view"}>
                                        <Tooltip
                                            title={`Roll Back to ${setting.deskNameObj[rollBackLevel]}`}
                                        >
                                            <Popconfirm
                                                title={`Are you sure to move student to  ${setting.deskNameObj[rollBackLevel] === "Front Desk"
                                                    ? (setting.deskNameObj[rollBackLevel] =
                                                        "Counselling Desk")
                                                    : setting.deskNameObj[rollBackLevel]
                                                    }`}
                                                onConfirm={() => this.mainNew({ key: "rollback" })}
                                                onCancel={() => {
                                                }}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button
                                                    shape="circle"
                                                    size={"medium"}
                                                    className={styles.btnInfo}
                                                    icon="rollback"
                                                />
                                            </Popconfirm>
                                        </Tooltip>
                                    </RightsWrapper>
                                </React.Fragment>
                            )}
                            {showDesks && (
                                <React.Fragment>
                                    <RightsWrapper myRight={"RollBack.view"}>
                                        <Tooltip title="Roll Back">
                                            <Button
                                                shape="circle"
                                                size={"medium"}
                                                className={styles.btnInfo}
                                                onClick={() => {
                                                    this.showDrawer();
                                                }}
                                                icon="rollback"
                                            />
                                        </Tooltip>
                                    </RightsWrapper>
                                </React.Fragment>
                            )}

                            <React.Fragment>
                                <RightsWrapper myRight={"ArchiveDesk.view"}>
                                    <Tooltip title={`Move to archive desk`}>
                                        <Popconfirm
                                            title={`Are you sure to move student to archive desk`}
                                            onConfirm={() => this.mainNew({ key: "archive" })}
                                            onCancel={() => {
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                shape="circle"
                                                size={"medium"}
                                                className={styles.btnInfo}
                                            >
                                                <FaArchive />
                                            </Button>
                                        </Popconfirm>
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>

                            <React.Fragment>
                                <RightsWrapper myRight={"DeadInquiry.view"}>
                                    <Tooltip title="Dead Inquiry">
                                        <Popconfirm
                                            title="Are you sure to dead this inquiry?"
                                            onConfirm={() => {
                                                this.sendBack("Dead Inquiry");
                                            }}
                                            onCancel={() => {
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                type={"danger"}
                                                size={"medium"}
                                                shape="circle"
                                                className={styles.btnWarning}
                                            ><FaBookDead /></Button>
                                        </Popconfirm>
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment>
                            <React.Fragment>
                                <RightsWrapper myRight={"Student.delete"}>
                                    <Tooltip title="Delete Student ">
                                        <Popconfirm
                                            title="Are you sure to delete this student?"
                                            onConfirm={() => {
                                                this.deleteStudent();
                                            }}
                                            onCancel={() => {
                                                console.log();
                                            }}
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Button
                                                shape="circle"
                                                size={"medium"}
                                                className={styles.btnDanger}
                                                type="danger"
                                                icon="cross"
                                            />
                                        </Popconfirm>
                                    </Tooltip>
                                </RightsWrapper>
                            </React.Fragment> */}
                            <Row>
                                <Col span={24} style={{ marginBottom: '16px' }}>
                                    <div style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        background: '#ffffff',
                                        padding: '6px 12px',
                                        borderRadius: '30px', // Capsule container
                                        border: '1px solid #f0f0f0',
                                        boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                                    }}>
                                        {/* 1. Profile Sheet */}
                                        <RightsWrapper>
                                            <Tooltip title="Profile Sheet">
                                                <Button
                                                    shape="circle"
                                                    className={styles.btnSuccess}
                                                    onClick={() => this.mainNew({ key: "profile" })}
                                                    icon="user"
                                                    style={{ border: 'none', background: '#52c41a', color: '#fff' }}
                                                />
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* 2. Follow Ups */}
                                        <RightsWrapper myRight={"FollowUps.view"}>
                                            <Tooltip title="Follow Ups">
                                                <Button
                                                    shape="circle"
                                                    className={styles.btnPrimary}
                                                    onClick={() => this.mainNew({ key: "followUps" })}
                                                    icon="snippets"
                                                    style={{ border: 'none', background: '#1890ff', color: '#fff' }}
                                                />
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* 3. SMS */}
                                        <RightsWrapper>
                                            <Tooltip title="SMS">
                                                <Button
                                                    shape="circle"
                                                    className={styles.btnPrimary}
                                                    onClick={() => this.showSMS()}
                                                    icon="message"
                                                    style={{ border: 'none', background: '#1890ff', color: '#fff' }}
                                                />
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* 4. WhatsApp */}
                                        <RightsWrapper>
                                            <Tooltip title="WhatsApp">
                                                <Button
                                                    shape="circle"
                                                    className={styles.btnPrimary}
                                                    onClick={() => this.showWhats()}
                                                    style={{ border: 'none', background: '#25D366', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                                >
                                                    <FaWhatsapp style={{ fontSize: '18px' }} />
                                                </Button>
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* 5. Email */}
                                        <RightsWrapper>
                                            <Tooltip title="Email">
                                                <Button
                                                    shape="circle"
                                                    className={styles.btnSuccess}
                                                    onClick={() => this.showEmail()}
                                                    icon="mail"
                                                    style={{ border: 'none', background: '#52c41a', color: '#fff' }}
                                                />
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* 6. Courier */}
                                        <RightsWrapper>
                                            <Tooltip title="Courier">
                                                <Button
                                                    shape="circle"
                                                    className={styles.btnPrimary}
                                                    onClick={() => this.mainNew({ key: "communication:courier" })}
                                                    icon="build"
                                                    style={{ border: 'none', background: '#1890ff', color: '#fff' }}
                                                />
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* Vertical Divider for Safety Actions */}
                                        <div style={{ width: '1px', height: '20px', background: '#f0f0f0', margin: '0 4px' }} />

                                        {/* 7. Roll Back (Conditional) */}
                                        {rollBackLevel && !showDesks && (
                                            <RightsWrapper myRight={"RollBack.view"}>
                                                <Tooltip title={`Roll Back to ${setting.deskNameObj[rollBackLevel]}`}>
                                                    <Popconfirm
                                                        title={`Are you sure to move student to ${setting.deskNameObj[rollBackLevel] === "Front Desk" ? "Counselling Desk" : setting.deskNameObj[rollBackLevel]}`}
                                                        onConfirm={() => this.mainNew({ key: "rollback" })}
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <Button shape="circle" icon="rollback" style={{ border: 'none', background: '#13c2c2', color: '#fff' }} />
                                                    </Popconfirm>
                                                </Tooltip>
                                            </RightsWrapper>
                                        )}

                                        {/* 8. Show Desks Rollback */}
                                        {showDesks && (
                                            <RightsWrapper myRight={"RollBack.view"}>
                                                <Tooltip title="Roll Back">
                                                    <Button
                                                        shape="circle"
                                                        onClick={() => this.showDrawer()}
                                                        icon="rollback"
                                                        style={{ border: 'none', background: '#13c2c2', color: '#fff' }}
                                                    />
                                                </Tooltip>
                                            </RightsWrapper>
                                        )}

                                        {/* 9. Archive */}
                                        <RightsWrapper myRight={"ArchiveDesk.view"}>
                                            <Tooltip title="Move to Archive">
                                                <Popconfirm
                                                    title="Are you sure to move student to archive desk?"
                                                    onConfirm={() => this.mainNew({ key: "archive" })}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button shape="circle" style={{ border: 'none', background: '#faad14', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <FaArchive />
                                                    </Button>
                                                </Popconfirm>
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* 10. Dead Inquiry */}
                                        <RightsWrapper myRight={"DeadInquiry.view"}>
                                            <Tooltip title="Dead Inquiry">
                                                <Popconfirm
                                                    title="Are you sure to dead this inquiry?"
                                                    onConfirm={() => this.sendBack("Dead Inquiry")}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button shape="circle" style={{ border: 'none', background: '#bfbfbf', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <FaBookDead />
                                                    </Button>
                                                </Popconfirm>
                                            </Tooltip>
                                        </RightsWrapper>

                                        {/* 11. Delete (Danger) */}
                                        <RightsWrapper myRight={"Student.delete"}>
                                            <Tooltip title="Delete Student">
                                                <Popconfirm
                                                    title="Are you sure to delete this student?"
                                                    onConfirm={() => this.deleteStudent()}
                                                    okText="Yes"
                                                    cancelText="No"
                                                >
                                                    <Button
                                                        shape="circle"
                                                        type="danger"
                                                        icon="cross"
                                                        style={{ boxShadow: '0 2px 4px rgba(255, 77, 79, 0.2)' }}
                                                    />
                                                </Popconfirm>
                                            </Tooltip>
                                        </RightsWrapper>
                                    </div>
                                </Col>
                            </Row>
                            <Drawer
                                title=""
                                placement="right"
                                closable={true}
                                onClose={() => {
                                    this.setState({
                                        visible: false,
                                    });
                                }}
                                visible={this.state.visible}
                                width={400}
                            >
                                <div style={{ marginLeft: 20, marginRight: 20 }}>

                                    <Row>
                                        <Col span={24}>
                                            <h3 style={{ marginTop: 20 }}>Select Desk</h3>
                                        </Col>
                                        <Col span={24}>
                                            <Select
                                                allowClear={true}
                                                defaultValue={""}
                                                placeholder={"Select Desk"}
                                                style={{ width: "200px" }}
                                                onChange={(val) => {
                                                    this.setState({ desk: val });
                                                }}
                                            >
                                                <Option value="">Choose Option</Option>
                                                {
                                                    deskOptions
                                                }
                                            </Select>
                                            <Popconfirm
                                                title={
                                                    "Are you sure to move student to your chosen desk ?"
                                                }
                                                onConfirm={() => {
                                                    this.sendBack(this.state.desk);
                                                }}
                                                onCancel={() => {
                                                    console.log();
                                                }}
                                                okText="Yes"
                                                cancelText="No"
                                            >
                                                <Button
                                                    type={"primary"}
                                                    size={"small"}
                                                    style={{ marginLeft: "30px" }}
                                                >
                                                    OK
                                                </Button>
                                            </Popconfirm>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <h3 style={{ marginTop: 20 }}>Select User</h3>
                                            {
                                                allUsers ?
                                                    <Select
                                                        allowClear={true}
                                                        placeholder={"Select User"}
                                                        style={{ width: "200px" }}
                                                        showSearch={true}
                                                        optionFilterProp="name"
                                                        options={allUsers}
                                                        value={this.state.moveReasonUser}
                                                        onChange={(val) => {
                                                            this.setState({ moveReasonUser: val });
                                                        }}
                                                        filterOption={(input, option) => {
                                                            return (
                                                                option.props.children
                                                                    .toLowerCase()
                                                                    .indexOf(input.toLowerCase()) >= 0
                                                            );
                                                        }}
                                                    >
                                                        {
                                                            allUsers.map((user, index) => {
                                                                return (<Option key={index} value={user._id}>{user.name}</Option>)
                                                            })
                                                        }
                                                    </Select>
                                                    : null
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <h3 style={{ marginTop: 20 }}>Select Move Type</h3>
                                        </Col>
                                        <Col span={24}>
                                            <Select
                                                allowClear={true}
                                                showSearch={true}
                                                placeholder={"Select Move Type"}
                                                style={{ width: "200px" }}
                                                onChange={(val) => {
                                                    this.setState({ moveReasonType: val })
                                                }}
                                            >
                                                <Option value="User’s Mistake">User’s Mistake</Option>
                                                <Option value="Other reason">Other reason</Option>
                                            </Select>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col span={24}>
                                            <h3 style={{ marginTop: 20 }}>Write down the reason</h3>
                                        </Col>
                                        <Col span={24}>
                                            <TextArea
                                                name="move_reason"
                                                onChange={(e) => {
                                                    this.setState({ moveReason: e.target.value })
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </div>
                            </Drawer>
                        </div>
                    </Col>
                    <Col span={19} />
                </Row>
                {/* <Row>
                    <Col span={24}>
                    <Router>
                    <RightsWrapper myRight={"DeskSubMenu.view"}>
                    <Menu
                    selectedKeys={[this.state.current]}
                    onClick={this.mainNew}
                    mode="horizontal"
                    className={styles.fullMenu}
                    >
                    <Menu.Item className={styles.menuItem} key="inquiryedit1">
                    <Icon type="appstore" /> Inquiry
                    </Menu.Item>
                    {deskName[atLevel] >= 0 && (
                    <Menu.Item className={styles.menuItem} key="updateCousenlling">
                    Counselling
                    </Menu.Item>
                    )}
                    
                    {deskName[atLevel] >= 1 && (
                    <Menu.Item className={styles.menuItem} key="registration">
                    Registration
                    </Menu.Item>
                    )}
                    
                    {deskName[atLevel] >= 2 && (
                    <Menu.Item className={styles.menuItem} key="editApplication">
                    Application
                    </Menu.Item>
                    )}
                    {deskName[atLevel] >= 3 && (
                    <Menu.Item className={styles.menuItem} key="visaProcessing">
                    Visa
                    </Menu.Item>
                    )}
                    {deskName[atLevel] >= 4 && (
                    <Menu.Item className={styles.menuItem} key="claimProcessing">
                    Claim
                    </Menu.Item>
                    )}
                    {deskName[atLevel] >= 5 && (
                    <Menu.Item className={styles.menuItem} key="Archive">
                    Archive
                    </Menu.Item>
                    )}
                    
                    <Menu.Item className={styles.menuItem} key="activity">Activity</Menu.Item>
                    <Menu.Item className={styles.menuItem} key="communication-history">Communication History</Menu.Item>
                    <Menu.Item className={styles.menuItem} key="rating-history">Rating History</Menu.Item>
                    <Menu.Item className={styles.menuItem} key="addFamilyAndFinance">Family And Finance</Menu.Item>
                    <Menu.Item className={styles.menuItem} key="documents">All Documents</Menu.Item>
                    </Menu>
                    </RightsWrapper>
                    </Router>
                    </Col>
                    </Row> */}
                <Row>
                    <Col span={24}>
                        <Router>
                            <RightsWrapper myRight={"DeskSubMenu.view"}>
                                <div className="modern-menu-row">
                                    <div className="menu-group-main">
                                        {/* Inquiry - Hamesha visible */}
                                        <div
                                            className={`menu-item-custom ${this.state.current === 'inquiryedit1' ? 'active' : ''}`}
                                            onClick={() => this.mainNew({ key: 'inquiryedit1' })}
                                        >
                                            <Icon type="search" /> Inquiry
                                        </div>

                                        {deskName[atLevel] >= 0 && (
                                            <div className={`menu-item-custom ${this.state.current === 'updateCousenlling' ? 'active' : ''}`}
                                                onClick={() => this.mainNew({ key: 'updateCousenlling' })}>
                                                <Icon type="customer-service" /> Counselling
                                            </div>
                                        )}

                                        {deskName[atLevel] >= 1 && (
                                            <div className={`menu-item-custom ${this.state.current === 'registration' ? 'active' : ''}`}
                                                onClick={() => this.mainNew({ key: 'registration' })}>
                                                <Icon type="form" /> Registration
                                            </div>
                                        )}

                                        {deskName[atLevel] >= 2 && (
                                            <div className={`menu-item-custom ${this.state.current === 'editApplication' ? 'active' : ''}`}
                                                onClick={() => this.mainNew({ key: 'editApplication' })}>
                                                <Icon type="profile" /> Application
                                            </div>
                                        )}

                                        {deskName[atLevel] >= 3 && (
                                            <div className={`menu-item-custom ${this.state.current === 'visaProcessing' ? 'active' : ''}`}
                                                onClick={() => this.mainNew({ key: 'visaProcessing' })}>
                                                <Icon type="global" /> Visa
                                            </div>
                                        )}

                                        {deskName[atLevel] >= 4 && (
                                            <div className={`menu-item-custom ${this.state.current === 'claimProcessing' ? 'active' : ''}`}
                                                onClick={() => this.mainNew({ key: 'claimProcessing' })}>
                                                <Icon type="dollar" /> Claim
                                            </div>
                                        )}
                                    </div>

                                    <div className="menu-divider-v" />

                                    <div className="menu-group-secondary">
                                        <div className={`menu-item-custom info-btn ${this.state.current === 'documents' ? 'active' : ''}`}
                                            onClick={() => this.mainNew({ key: 'documents' })}>
                                            <Icon type="file-protect" /> Documents
                                        </div>

                                        <div className={`menu-item-custom info-btn ${this.state.current === 'communication-history' ? 'active' : ''}`}
                                            onClick={() => this.mainNew({ key: 'communication-history' })}>
                                            <Icon type="message" /> Communication History
                                        </div>

                                        {/* Baki items Dropdown mein taaki ek row mein fit rahe */}
                                        <Menu
                                            onClick={this.mainNew}
                                            selectedKeys={[this.state.current]}
                                            mode="horizontal"
                                            className="more-dropdown-menu"
                                        >
                                            <Menu.SubMenu
                                                title={<span><Icon type="more" /> More</span>}
                                            >
                                                <Menu.Item key="addFamilyAndFinance"><Icon type="bank" /> Family And Finance</Menu.Item>
                                                <Menu.Item key="activity"><Icon type="thunderbolt" /> Activity</Menu.Item>
                                                <Menu.Item key="rating-history"><Icon type="star" /> Rating History</Menu.Item>
                                            </Menu.SubMenu>
                                        </Menu>
                                    </div>
                                </div>
                            </RightsWrapper>
                        </Router>
                    </Col>
                </Row>
            </Card>
        );
    }
}

// export default StudentHeader

const mapStateToProps = ({ global, router }) => ({
    pathname: router.location.pathname,
    search: router.location.search
});

export default connect(
    mapStateToProps,
    {}
)(StudentHeader);
